module.exports = __webpack_public_path__ + "img/70.3a941bb7.png";